<template>
    <div>
        <div>
            <el-button
                v-if="editable"
                style="width: 120px"
                class="p-5px"
                size="small"
                type="primary"
                icon="el-icon-refresh"
                @click="updateCustomerValues()"
                >{{ $t('Update Values') }}</el-button
            >
        </div>
        <table class="table-wrapper">
            <tr>
                <th class="header" colspan="2">{{ $t('NAME') }}</th>
                <th class="header" colspan="2">{{ $t('TSI') }}</th>
                <th class="header" colspan="2">{{ $t('PRIMARY EML BLOCK') }}</th>
                <th class="header" colspan="2">{{ $t('EML') }}</th>
                <th class="header" colspan="2">{{ $t('CNLE') }}</th>
                <th class="header" colspan="2">{{ $t('TNLE') }}</th>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('PROPERTY DAMAGE') }}</td>
                <td class="col2 center" colspan="2">{{ data.tsi.currency }}</td>
                <td class="col3 center">{{ $t('% of TSI') }}</td>
                <td class="col4 center">{{ data.prieml.currency }}</td>
                <td class="col5 center">{{ $t('% in EML Block') }}</td>
                <td class="col6 center">{{ data.eml.currency }}</td>
                <td class="col7 center">{{ $t('% in EML Block') }}</td>
                <td class="col8 center">{{ data.cnle.currency }}</td>
                <td class="col9 center">{{ $t('% in EML Block') }}</td>
                <td class="col10 center">{{ data.tnle.currency }}</td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Buildings') }}</td>
                <td class="col2 right" colspan="2">
                    {{ parseNumberValue(data.tsi.building_value) }}
                </td>
                <td class="col3 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.prieml.building_ratio"
                    ></el-input>
                </td>
                <td class="col4 right">
                    {{
                        calcValue(
                            'tsi',
                            'prieml',
                            'building_value',
                            'building_ratio',
                            'building_value'
                        )
                    }}
                </td>
                <td class="col5 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.eml.building_ratio"
                    ></el-input>
                </td>
                <td class="col6 right">
                    {{
                        calcValue(
                            'prieml',
                            'eml',
                            'building_value',
                            'building_ratio',
                            'building_value'
                        )
                    }}
                </td>
                <td class="col7 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.cnle.building_ratio"
                    ></el-input>
                </td>
                <td class="col8 right">
                    {{
                        calcValue(
                            'prieml',
                            'cnle',
                            'building_value',
                            'building_ratio',
                            'building_value'
                        )
                    }}
                </td>
                <td class="col9 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.tnle.building_ratio"
                    ></el-input>
                </td>
                <td class="col10 right">
                    {{
                        calcValue(
                            'prieml',
                            'tnle',
                            'building_value',
                            'building_ratio',
                            'building_value'
                        )
                    }}
                </td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Plant&Equipment') }}</td>
                <td class="col2 right" colspan="2">
                    {{ parseNumberValue(data.tsi.plant_equipment_value) }}
                </td>
                <td class="col3 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.prieml.plant_equipment_ratio"
                    ></el-input>
                </td>
                <td class="col4 right">
                    {{
                        calcValue(
                            'tsi',
                            'prieml',
                            'plant_equipment_value',
                            'plant_equipment_ratio',
                            'plant_equipment_value'
                        )
                    }}
                </td>
                <td class="col5 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.eml.plant_equipment_ratio"
                    ></el-input>
                </td>
                <td class="col6 right">
                    {{
                        calcValue(
                            'prieml',
                            'eml',
                            'plant_equipment_value',
                            'plant_equipment_ratio',
                            'plant_equipment_value'
                        )
                    }}
                </td>
                <td class="col7 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.cnle.plant_equipment_ratio"
                    ></el-input>
                </td>
                <td class="col8 right">
                    {{
                        calcValue(
                            'prieml',
                            'cnle',
                            'plant_equipment_value',
                            'plant_equipment_ratio',
                            'plant_equipment_value'
                        )
                    }}
                </td>
                <td class="col9 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.tnle.plant_equipment_ratio"
                    ></el-input>
                </td>
                <td class="col10 right">
                    {{
                        calcValue(
                            'prieml',
                            'tnle',
                            'plant_equipment_value',
                            'plant_equipment_ratio',
                            'plant_equipment_value'
                        )
                    }}
                </td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Stock') }}</td>
                <td class="col2 right" colspan="2">{{ parseNumberValue(data.tsi.stock_value) }}</td>
                <td class="col3 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.prieml.stock_ratio"
                    ></el-input>
                </td>
                <td class="col4 right">
                    {{ calcValue('tsi', 'prieml', 'stock_value', 'stock_ratio', 'stock_value') }}
                </td>
                <td class="col5 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.eml.stock_ratio"
                    ></el-input>
                </td>
                <td class="col6 right">
                    {{ calcValue('prieml', 'eml', 'stock_value', 'stock_ratio', 'stock_value') }}
                </td>
                <td class="col7 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.cnle.stock_ratio"
                    ></el-input>
                </td>
                <td class="col8 right">
                    {{ calcValue('prieml', 'cnle', 'stock_value', 'stock_ratio', 'stock_value') }}
                </td>
                <td class="col9 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.tnle.stock_ratio"
                    ></el-input>
                </td>
                <td class="col10 right">
                    {{ calcValue('prieml', 'tnle', 'stock_value', 'stock_ratio', 'stock_value') }}
                </td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Other') }}</td>
                <td class="col2 right" colspan="2">{{ parseNumberValue(data.tsi.other_value) }}</td>
                <td class="col3 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.prieml.other_ratio"
                    ></el-input>
                </td>
                <td class="col4 right">
                    {{ calcValue('tsi', 'prieml', 'other_value', 'other_ratio', 'other_value') }}
                </td>
                <td class="col5 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.eml.other_ratio"
                    ></el-input>
                </td>
                <td class="col6 right">
                    {{ calcValue('prieml', 'eml', 'other_value', 'other_ratio', 'other_value') }}
                </td>
                <td class="col7 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.cnle.other_ratio"
                    ></el-input>
                </td>
                <td class="col8 right">
                    {{ calcValue('prieml', 'cnle', 'other_value', 'other_ratio', 'other_value') }}
                </td>
                <td class="col9 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.tnle.other_ratio"
                    ></el-input>
                </td>
                <td class="col10 right">
                    {{ calcValue('prieml', 'tnle', 'other_value', 'other_ratio', 'other_value') }}
                </td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Total PD Value') }}</td>
                <td class="col2 right" colspan="2">{{ calcPDValue() }}</td>
                <td class="col3"></td>
                <td class="col4"></td>
                <td class="col5"></td>
                <td class="col6"></td>
                <td class="col7"></td>
                <td class="col8"></td>
                <td class="col9"></td>
                <td class="col10"></td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Total PD Loss Estimates') }}</td>
                <td class="col2" colspan="2"></td>
                <td class="col3"></td>
                <td class="col4 right">{{ calcTotalPDLossEstimates(data.prieml) }}</td>
                <td class="col5"></td>
                <td class="col6 right">{{ calcTotalPDLossEstimates(data.eml) }}</td>
                <td class="col7"></td>
                <td class="col8 right">{{ calcTotalPDLossEstimates(data.cnle) }}</td>
                <td class="col9"></td>
                <td class="col10 right">{{ calcTotalPDLossEstimates(data.tnle) }}</td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('BUSINESS INTERRUPTION') }}</td>
                <td class="col2 center" colspan="2">{{ data.tsi.bi_currency }}</td>
                <td class="col3 center">{{ $t('% of TSI') }}</td>
                <td class="col4 center">{{ data.prieml.bi_currency }}</td>
                <td class="col5 center">{{ $t('Days in EML Block') }}</td>
                <td class="col6 center">{{ data.eml.bi_currency }}</td>
                <td class="col7 center">{{ $t('Days in EML Block') }}</td>
                <td class="col8 center">{{ data.cnle.bi_currency }}</td>
                <td class="col9 center">{{ $t('Days in EML Block') }}</td>
                <td class="col10 center">{{ data.tnle.bi_currency }}</td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Indemnity Period') }}</td>
                <td class="col2 right" colspan="2">{{ data.tsi.indemnity_period }}</td>
                <td class="col3"></td>
                <td class="col4"></td>
                <td class="col5"></td>
                <td class="col6"></td>
                <td class="col7"></td>
                <td class="col8"></td>
                <td class="col9"></td>
                <td class="col10"></td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Total BI Value') }}</td>
                <td class="col2 right" colspan="2">
                    {{ parseNumberValue(data.tsi.total_bi_value) }}
                </td>
                <td class="col3"></td>
                <td class="col4"></td>
                <td class="col5"></td>
                <td class="col6"></td>
                <td class="col7"></td>
                <td class="col8"></td>
                <td class="col9"></td>
                <td class="col10"></td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Total BI Loss Estimates') }}</td>
                <td class="col2" colspan="2"></td>
                <td class="col3 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.prieml.total_bi_le_ratio"
                    ></el-input>
                </td>
                <td class="col4 right">
                    {{
                        calcLEValue(
                            'tsi',
                            'prieml',
                            'total_bi_value',
                            'total_bi_le_ratio',
                            'total_bi_le_value'
                        )
                    }}
                </td>
                <td class="col5 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.eml.total_bi_le_ratio"
                    ></el-input>
                </td>
                <td class="col6 right">
                    {{
                        calcLEValue30(
                            'prieml',
                            'eml',
                            'total_bi_le_value',
                            'total_bi_le_ratio',
                            'total_bi_le_value'
                        )
                    }}
                </td>
                <td class="col7 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.cnle.total_bi_le_ratio"
                    ></el-input>
                </td>
                <td class="col8 right">
                    {{
                        calcLEValue30(
                            'prieml',
                            'cnle',
                            'total_bi_le_value',
                            'total_bi_le_ratio',
                            'total_bi_le_value'
                        )
                    }}
                </td>
                <td class="col9 input">
                    <el-input
                        type="number"
                        :disabled="!editable"
                        v-model.number="data.tnle.total_bi_le_ratio"
                    ></el-input>
                </td>
                <td class="col10 right">
                    {{
                        calcLEValue30(
                            'prieml',
                            'tnle',
                            'total_bi_le_value',
                            'total_bi_le_ratio',
                            'total_bi_le_value'
                        )
                    }}
                </td>
            </tr>
            <tr>
                <td class="col1" colspan="2">{{ $t('Total PD + BI Value') }}</td>
                <td class="col2 right" colspan="2">{{ calcTotalPdBiValue() }}</td>
                <td class="col3"></td>
                <td class="col4"></td>
                <td class="col5"></td>
                <td class="col6"></td>
                <td class="col7"></td>
                <td class="col8"></td>
                <td class="col9"></td>
                <td class="col10"></td>
            </tr>

            <tr>
                <td class="col1" colspan="2">{{ $t('Total PD + BI Loss Estimates') }}</td>
                <td class="col2" colspan="2"></td>
                <td class="col3"></td>
                <td class="col4 right">{{ calcTotalPdBiLossEstimates(data.prieml) }}</td>
                <td class="col5"></td>
                <td class="col6 right">{{ calcTotalPdBiLossEstimates(data.eml) }}</td>
                <td class="col7"></td>
                <td class="col8 right">{{ calcTotalPdBiLossEstimates(data.cnle) }}</td>
                <td class="col9"></td>
                <td class="col10 right">{{ calcTotalPdBiLossEstimates(data.tnle) }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import Visit from '@/data/Visit';

const formatDecimal = require('format-decimal');

export default {
    name: 'rsalossestimates',
    components: {},
    props: {
        question: { type: FormQuestion, required: true },
        editable: {
            type: Boolean,
            default: true,
        },
        visit: {
            type: Visit,
            required: true,
        },
    },
    data() {
        return {
            data: { tsi: {}, prieml: {}, eml: {}, cnle: {}, tnle: {} },
        };
    },
    created() {
        // todo musa get data from visit
        if (!this.question.data.return_value) {
            this.setCustomerValues();
            // this.question.data.return_value
            // this.data = {
            //     tsi: {
            //         currency: 'TSI Cur.',
            //         building_value: 10000,
            //         plant_equipment_value: 20000,
            //         stock_value: 30000,
            //         other_value: 40000,
            //         bi_currency: 'BI Cur.',
            //         indemnity_period: 10,
            //         total_bi_value: 50000,
            //     },
            //     prieml: {
            //         currency: 'Pr Cur.',
            //         bi_currency: 'Bi Cur.',
            //     },
            //     eml: {
            //         currency: 'EML Cur.',
            //         bi_currency: 'Bi EML Cur.',
            //     },
            //     cnle: {
            //         currency: 'CNLE Cur.',
            //         bi_currency: 'Bi CNLE Cur.',
            //     },
            //     tnle: {
            //         currency: 'TNLE Cur.',
            //         bi_currency: 'Bi TNLE Cur.',
            //     },
            // };
        } else {
            this.data = JSON.parse(this.question.data.return_value || '{}');
        }
    },
    mounted() {},
    watch: {
        data: {
            // This will let Vue know to look inside the array
            deep: true,
            // immediate: true,
            // We have to move our method to a handler field
            handler(newVal) {
                this.question.data.return_value = JSON.stringify(newVal);
            },
        },
    },
    computed: {
        currencyList() {
            return this.$store.getters.currencyList;
        },
        calcValue() {
            return (oper1, oper2, input1, input2, output) => {
                this.data[oper2][output] = parseFloat(
                    ((this.data[oper1][input1] * this.data[oper2][input2]) / 100)?.toFixed(2)
                );
                return this.parseNumberValue(this.data[oper2][output] || null);
            };
        },

        calcLEValue() {
            return (oper1, oper2, input1, input2, output) => {
                this.data[oper2][output] = parseFloat(
                    ((this.data[oper1][input1] * this.data[oper2][input2]) / 100)?.toFixed(2)
                );
                return this.parseNumberValue(this.data[oper2][output] || null);
            };
        },
        calcLEValue30() {
            return (oper1, oper2, input1, input2, output) => {
                this.data[oper2][output] = parseFloat(
                    (
                        (this.data[oper1][input1] * this.data[oper2][input2]) /
                        (30 * this.data.tsi.indemnity_period)
                    )?.toFixed(2)
                );
                return this.parseNumberValue(this.data[oper2][output] || null);
            };
        },
    },

    methods: {
        setCustomerValues() {
            if (this.editable) {
                const {
                    building_value,
                    plant_value,
                    stock_value,
                    other_value,
                    gross_profit_value,
                    indemnity_period,
                } = this.visit.address;

                const { currency_name } = this.visit.customer;

                // const currency = this.currencyList.find(element => element.id == currency_id);

                this.data.tsi = {
                    ...this.data.tsi,
                    currency: currency_name,
                    building_value,
                    plant_equipment_value: plant_value,
                    stock_value,
                    other_value,
                    total_bi_value: gross_profit_value,
                    bi_currency: currency_name,
                    indemnity_period,
                };

                this.data.prieml = {
                    ...this.data.prieml,
                    currency: currency_name,
                    bi_currency: currency_name,
                };

                this.data.eml = {
                    ...this.data.eml,
                    currency: currency_name,
                    bi_currency: currency_name,
                };
                this.data.cnle = {
                    ...this.data.cnle,
                    currency: currency_name,
                    bi_currency: currency_name,
                };
                this.data.tnle = {
                    ...this.data.tnle,
                    currency: currency_name,
                    bi_currency: currency_name,
                };
            }
        },
        updateCustomerValues() {
            this.setCustomerValues();
        },
        calcTotalPDLossEstimates(column) {
            column.total_pd_le =
                (column.building_value || 0) +
                    (column.plant_equipment_value || 0) +
                    (column.stock_value || 0) +
                    (column.other_value || 0) || null;
            return this.parseNumberValue(column.total_pd_le);
        },
        calcPDValue() {
            this.data.tsi.total_pd_value =
                (this.data.tsi.building_value || 0) +
                    (this.data.tsi.plant_equipment_value || 0) +
                    (this.data.tsi.stock_value || 0) +
                    (this.data.tsi.other_value || 0) || null;
            return this.parseNumberValue(this.data.tsi.total_pd_value);
        },
        calcTotalPdBiValue() {
            this.data.tsi.total_pd_bi_value =
                this.calcPDValue() + this.data.tsi.total_bi_value || null;
            return this.parseNumberValue(this.data.tsi.total_pd_bi_value);
        },
        calcTotalPdBiLossEstimates(column) {
            column.total_pd_bi_le =
                parseFloat(
                    ((column.total_pd_le || 0) + (column.total_bi_le_value || 0))?.toFixed(2)
                ) || null;
            return this.parseNumberValue(column.total_pd_bi_le);
        },
        parseNumberValue(value, thousandSeperator = '.', decimalSeparator = ',') {
            let formattedValue;
            try {
                formattedValue = formatDecimal(parseFloat(value), {
                    decimal: decimalSeparator,
                    thousands: thousandSeperator,
                    precision: 2,
                });

                if (formattedValue.split(decimalSeparator).length > 1) {
                    const [num, decimal] = formattedValue.split(decimalSeparator);

                    if (decimal == '00') {
                        formattedValue = num;
                    }
                }
            } catch (e) {
                return value;
            }
            return formattedValue;
        },
    },
};
</script>

<style lang="scss">
.table-wrapper {
    width: 100%;
    table-layout: fixed;
    border: 1px solid #ebeef5;
    line-height: 20px !important;
    overflow: auto;
    word-break: break-word;

    td {
        border-right: 1px solid #ebeef5;
        padding: 10px;
    }

    .input {
        padding: 0px;

        .el-input__inner {
            padding: 0px 0px 0px 15px;
        }
    }

    .right {
        text-align: right;
    }

    .center {
        text-align: center;
    }

    .col1 {
        background: #ebdff4;
    }

    .col2 {
        background: #f6f6f8;
    }

    .col3 {
        background: #ebdff4;
    }

    .col4 {
        background: #ebdff4;
    }

    .col5 {
        background: #f6f6f8;
    }

    .col6 {
        background: #f6f6f8;
    }

    .col7 {
        background: #ebdff4;
    }

    .col8 {
        background: #ebdff4;
    }

    .col9 {
        background: #f6f6f8;
    }

    .col10 {
        background: #f6f6f8;
    }

    th {
    }

    tr {
        border-bottom: 1px solid #ebeef5;
        height: 32px;
    }

    .header {
        background: #d3dce6;
        text-align: center;
        border-right: 1px solid #ebeef5;
    }

    .el-col {
        border-radius: 4px;
        border-bottom: 1px solid #ebeef5;
    }
}

.el-row {
    // margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>
